import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { UpgradeModule } from '@angular/upgrade/static';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgxMaskModule } from 'ngx-mask';

// import { NgxEditorModule } from 'ngx-editor';
// import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';

import { TokenInterceptorService } from './_shared/services/http-interceptor.service';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

// Layout components
import { HeaderComponent } from './_layout/header/header.component';
import { SidebarComponent } from './_layout/sidebar/sidebar.component';
import { BreadcrumbsComponent } from './_layout/breadcrumbs.component';

// import { ChartAccountsModule } from './chart-accounts/chart-accounts.module';

// Upgrading Angularjs services to use in Angular
import {
  versioningServiceProvider,
  routeParamsProvider,
  locationProvider,
  amMomentProvider,
  translateProvider,
  sessionServiceProvider,
  productCategoryServiceProvider,
  tourServiceProvider,
} from '../app/ajs/upgraded-providers.ajs';
// import { MAT_DATE_LOCALE } from '@angular/material/core';
// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    UpgradeModule,
    HeaderComponent,
    SidebarComponent,
    BreadcrumbsComponent,

    // Remove when products have been migrated to angular (problems when refresh page)
    // lazy loading Guard ??
    // ChartAccountsModule,

    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),

    // AngularMultiSelectModule

    /*NgxEditorModule.forRoot({
      locals: {
        // menu
        bold: 'Bold',
        italic: 'Italic',
        code: 'Code',
        blockquote: 'Blockquote',
        underline: 'Underline',
        strike: 'Strike',
        bullet_list: 'Bullet List',
        ordered_list: 'Ordered List',
        heading: 'Heading',
        h1: 'Header 1',
        h2: 'Header 2',
        h3: 'Header 3',
        h4: 'Header 4',
        h5: 'Header 5',
        h6: 'Header 6',
        align_left: 'Left Align',
        align_center: 'Center Align',
        align_right: 'Right Align',
        align_justify: 'Justify',
        text_color: 'Text Color',
        background_color: 'Background Color',

        // popups, forms, others...
        url: 'URL',
        text: 'Text',
        openInNewTab: 'Open in new tab',
        insert: 'Insert',
        altText: 'Alt Text',
        title: 'Title',
        remove: 'Remove',
      },
    }),*/
    NgxMaskModule.forRoot(),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true,
    },
    versioningServiceProvider,
    routeParamsProvider,
    locationProvider,
    amMomentProvider,
    translateProvider,
    sessionServiceProvider,
    productCategoryServiceProvider,
    tourServiceProvider,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}

// import { LayoutModule } from './_layout/layout.module';
// LayoutModule,

// import { PagesModule } from './_pages/pages.module'; // Remove if lazy loading is implemented
// PagesModule,
